import React, {useState} from 'react';
import './AddInputFormsForTroubles.scss';
import { setViewInputFormsForTroubles } from '../troubleslice';
import { idTroubleCreate } from '../../../Admin/adminSlice';

const AddInputFormsForTroubles = (props) => {

            
  const [inputContent, setInputContent] = useState();        
  const { dispatch } = props;
  
    // CLICK OK
    const onSend =() => {
        
          const item = {
            noteId: props.selectedNoteId,
            notePart: props.selectedPart,
            textTrouble: inputContent,
            userId: props.userId,
            imgPath: null,
               
            }
            console.log(item);
            dispatch(idTroubleCreate(item));
            dispatch(setViewInputFormsForTroubles());  
            
    }
    // ENTER INPUT
    const handleInputContent =(e)=> {
        setInputContent(e.target.value);
            
    }





    // CLOSE FORM
    const onClose=()=> {
    
     dispatch(setViewInputFormsForTroubles());

    }

    
        
            //console.log(this.props.adminState.openInputForms);
       // if (props.adminState.openAddInputFormsForAnswers) {
            return(
                <div className="AddInputFormsForTroubles ">
                            


                
                <form>
                <p>Задать вопрос:</p>
                    <label>
                        
                    <textarea  onChange={handleInputContent} 
                    ></textarea>
                    </label>

                </form>
                <button onClick={onSend}>Отправить</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       // } else return null;
        
        

            
    
}
export default AddInputFormsForTroubles;